import pageQuery from './Main.vue';

export default pageQuery;
